import React from 'react';

import Analytics from 'widgets/Analytics';

import { useThirdPartyScripts } from './hooks/useThirdPartyScripts';

type Props = {
  startTracking: boolean;
};

const ThirdPartyScriptsLoader: React.FC<Props> = ({ startTracking }) => {
  const shouldLoad = useThirdPartyScripts();

  if (!shouldLoad || !startTracking) return null;

  return <Analytics />;
};

export default ThirdPartyScriptsLoader;
